export default __webpack_public_path__ + "static/media/01.1778fa1e.jpg";